import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserSignupRoutingModule } from './user-signup-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserSignupRoutingModule,
  ]
})
export class UserSignupModule { }
